<script setup lang="ts">
import { computed } from 'vue'
import { useForm } from 'vee-validate'
import { toTypedSchema } from '@vee-validate/yup'
import { emailSchema } from '@/types'

const props = defineProps({
  loading: {
    type: Boolean,
  },
  usingCodeLogin: {
    type: Boolean,
  },
})

const emit = defineEmits(['send', 'code-login'])

const validationSchema = toTypedSchema(emailSchema)
const { handleSubmit, errors, defineField } = useForm({
  validationSchema,
})
const [email] = defineField('email')

const useLoginMethodText = computed(() => {
  return props.usingCodeLogin
    ? 'Login.HavingTroubleNotice.UseEmailLinkText'
    : 'Login.HavingTroubleNotice.UseCodeLinkText'
})

const sendEmail = handleSubmit((values) => {
  emit('send', values.email)
})

const handleCodeLogin = () => {
  emit('code-login', !props.usingCodeLogin)
}
</script>

<template>
  <form
    :aria-label="$t('Login.EmailForm.AriaLabel')"
    class="mt-4"
    novalidate
    @submit.prevent="sendEmail"
  >
    <div class="text-start mb-3">
      <label for="email" class="form-label fw-semibold">
        {{ $t('Login.EmailForm.EmailInput.Label') }}
      </label>
      <input
        id="email"
        v-model="email"
        name="email"
        class="form-control"
        :class="{ input: true, 'is-invalid': errors.email?.length }"
        spellcheck="false"
        type="email"
        autofocus
        autocomplete="email"
        placeholder="your.email@address.com"
      />
    </div>

    <div class="text-center mb-3">
      <button
        :disabled="loading"
        class="btn btn-primary"
        name="submit"
        type="submit"
      >
        <span
          v-if="loading"
          class="spinner-border spinner-border-sm me-2"
          aria-hidden="true"
        ></span>
        <span>
          {{ $t('Login.EmailForm.SubmitButton.Text') }}
        </span>
      </button>
    </div>

    <p class="small text-balance">
      {{ $t('Login.AgreementNotice.Part1') }}
      <a
        id="terms"
        href="https://www.swiftaid.co.uk/charity/terms/"
        rel="noopener noreferrer"
      >
        {{ $t('Login.AgreementNotice.TermsLinkText') }}
      </a>
      {{ $t('Login.AgreementNotice.Part2') }}
      <a
        id="privacy"
        href="https://swiftaid.co.uk/legal/privacy/"
        rel="noopener noreferrer"
      >
        {{ $t('Login.AgreementNotice.PrivacyLinkText') }}
      </a>
    </p>

    <p class="small">
      {{ usingCodeLogin ? null : $t('Login.HavingTroubleNotice.Question') }}
      <a id="codeLogin" href="#" @click.prevent="handleCodeLogin">
        {{ $t(useLoginMethodText) }}
      </a>
    </p>
  </form>
</template>
